module.exports = __webpack_public_path__ + "static/media/img-rede-programa.5db8d8ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/network/img-rede-programa.png
// module id = 649
// module chunks = 0